/**
 * 일지 발주 매칭 프로그래스바 — 런타임 갱신/폴링 모듈 ($j.F.Diary.ProgressBar).
 *
 * 최초 렌더는 ListRenderer.js(progressBar)가 하고, 여기서는 렌더된 진행바
 * (prder_proceed_status_*)를 5초 폴링(/m/ajax/orders/progress)으로 갱신한다.
 * 표시 규칙(채움 %·캡션·dense/done 클래스)은 ListRenderer.progressView 하나를 공유한다 —
 * 두 렌더 경로가 어긋나지 않게 하려는 것.
 *
 * [문제 수정] 단계 수는 최초 렌더 시점의 group_all 로 고정됐었다. 발주 직후 매칭단계가 아직
 * 없으면(group_all=0) 1칸 placeholder 로 렌더되고, 이후 서버에서 매칭단계가 생겨도 바가 멈춰
 * 있었다(새로고침해야 반영). → apply() 가 서버 group_all 로 매번 다시 그린다.
 *
 * 추적 대상은 화면(DOM)의 data_cd 를 단일 소스로 수집한다 — 서버 processArrayJs 나 경로별
 * (일별/달력) 수동 수집에 의존하던 불일치를 없앤다.
 *
 * 하위호환: 기존 전역 이름(check_Process_fallow / do_order_follow / show_results /
 * reset_processArray / re_Make_process_Array)을 그대로 등록한다(PHP 인라인·page_init·Calendar 호출).
 */

import DiaryList from './ListRenderer';

const POLL_MS = 5000;
const PROGRESS_URL = '/m/ajax/orders/progress';

let intervalId = null;

// window.processArray: 추적목록 [ [num, status, group_now, group_all, 0, 0], ... ] — 뒤 두 자리는 읽는 곳 없이 자리만 유지
function resetProcessArray() {
    window.processArray = [];
}
function pushProcessArray(dataarray) {
    if (!Array.isArray(window.processArray)) window.processArray = [];
    window.processArray.push(dataarray);
}

// 화면의 진행바 data_cd 를 스캔해 추적목록 재구성 (단일 소스 = DOM).
function collectFromDom(root) {
    root = root || document;
    resetProcessArray();
    const bars = root.querySelectorAll('[id^="prder_proceed_status_"]');
    for (let i = 0; i < bars.length; i++) {
        const cd = bars[i].getAttribute('data_cd');
        if (!cd || cd.indexOf(',') < 0) continue;
        const ea = cd.split(',');
        if (ea.length > 5) pushProcessArray(ea);
    }
}

// 진행바 다시 그리기 — 채움 폭·눈금 주기·캡션·상태 클래스. 단계 수(all)가 늘어도 그대로 반영된다.
function draw(onum, now, all, status) {
    const box = document.getElementById('prder_proceed_status_' + onum);
    if (!box) return null;
    const bar = box.querySelector('.jbpg-bar');
    const fill = box.querySelector('.jbpg-fill');
    if (!bar || !fill) return box;

    const pg = DiaryList.progressView(now, all, status);
    bar.style.setProperty('--jbpg-steps', all > 0 ? all : 1);
    fill.style.width = pg.pct + '%';
    const cap = box.querySelector('.jbpg-cap');
    if (cap) cap.innerHTML = pg.cap;
    box.className = 'jbpg' + pg.cls;   // 최초 렌더도 같은 조합이라 통째로 덮어써도 안전
    return box;
}

// 한 오더의 진행상황 반영 (구 show_results).
function apply(data) {
    const onum = parseInt(data[0], 10) || 0;
    const ostt = parseInt(data[1], 10) || 0;
    const st = parseInt(data[2], 10) || 0;
    const en = parseInt(data[3], 10) || 0;
    if (onum < 1 || en < 1) return;

    // 마지막 단계에 닿았거나 수주대기(4) 이후면 알림은 끝난 것으로 본다(구 동작 유지).
    // 마지막 그룹의 발송 완료가 폴링에 안 잡히는 경우가 있어 en-1 에서 종료 처리한다.
    const finished = st >= (en - 1) || ostt > 3;
    const box = draw(onum, finished ? en : st, en, ostt);

    if (box) {
        const cd = (box.getAttribute('data_cd') || '').split(',');
        if (cd.length > 3) {
            cd[1] = ostt; cd[2] = st; cd[3] = en;
            box.setAttribute('data_cd', cd.join(','));
        }
        if (ostt > 5) box.style.display = 'none';   // 배차 이후 — 진행바 자체를 감춘다
    }

    if (!finished) return;
    for (let i = window.processArray.length - 1; i >= 0; i--) {   // 추적 종료
        const org = window.processArray[i];
        if (Array.isArray(org) && org.length > 2 && org[0] == onum) window.processArray.splice(i, 1);
    }
}

// 폴링 1회 (구 do_order_follow).
function poll() {
    if (!Array.isArray(window.processArray) || window.processArray.length === 0) {
        stop();
        return;
    }
    let nums = '';
    for (let i = 0; i < window.processArray.length; i++) {
        const ea = window.processArray[i];
        if (Array.isArray(ea) && ea.length > 2) {
            let n = ea[0];
            if (isNaN(n)) n = 0;
            if (n > 0) nums += n + '|';
        }
    }
    if (nums.length === 0) return;
    $.ajax({
        type: 'GET', url: PROGRESS_URL,
        data: { jobtype: 'progress', orders: nums },
        success: function (rows) {
            $.each(rows, function (k, row) { apply(row); });
        }
    });
}

function stop() {
    if (intervalId != null) { clearInterval(intervalId); intervalId = null; }
}

// 시작 (구 check_Process_fallow) — DOM 에서 추적목록 수집 후 대상 있으면 폴링.
function start(root) {
    collectFromDom(root);
    if (Array.isArray(window.processArray) && window.processArray.length > 0) {
        poll();
        stop();
        intervalId = setInterval(poll, POLL_MS);
    } else {
        stop();
    }
}

export default class ProgressBar {
    constructor() {
        if (!Array.isArray(window.processArray)) window.processArray = [];
        Object.assign(window, {
            reset_processArray: resetProcessArray,
            re_Make_process_Array: pushProcessArray,
            check_Process_fallow: start,
            do_order_follow: poll,
            show_results: apply,
        });
    }
    start(root) { start(root); }
    stop() { stop(); }
    collect(root) { collectFromDom(root); }
}
